import * as React from "react";
import { useCallback, useState } from "react";
import styled, { css } from "styled-components";
import IconButton from "components/common/IconButton";
import useUpdateUserLayoutPreferences from "components/common/EntityDataTable/hooks/useUpdateUserLayoutPreferences";
import useTableFetchContext from "components/common/PaginatedEntityTable/useTableFetchContext";
import useUserLayoutPreferences from "components/common/EntityDataTable/hooks/useUserLayoutPreferences";
import Spinner from "components/common/Spinner";
import useLayoutVariant from "components/common/PaginatedEntityTable/hooks/useLayoutVariant";
const Container = styled.div(
  ({ theme }) => css`
    margin: ${theme.spacings.xs} 0 ${theme.spacings.sm} 0;
  `
);
const HeadlineContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;
const EventsMetrics = ({ children = void 0, expanded: initialExpanded, onExpandToggle }) => {
  const [expanded, setExpanded] = useState(initialExpanded);
  const expandTitle = `${expanded ? "Collapse" : "Expand"} Metrics`;
  const expandIcon = expanded ? "unfold_less" : "unfold_more";
  const onClick = useCallback(
    () => setExpanded((_expanded) => {
      const newValue = !_expanded;
      onExpandToggle(newValue);
      return newValue;
    }),
    [onExpandToggle]
  );
  return /* @__PURE__ */ React.createElement(Container, null, /* @__PURE__ */ React.createElement(HeadlineContainer, null, /* @__PURE__ */ React.createElement("h2", null, "Metrics"), /* @__PURE__ */ React.createElement(IconButton, { title: expandTitle, name: expandIcon, onClick })), expanded ? children : null);
};
const EventsMetricsBarrier = ({ children = void 0 }) => {
  var _a, _b;
  const { entityTableId } = useTableFetchContext();
  const { activeLayoutVariant } = useLayoutVariant();
  const { mutateAsync: updatePreferences } = useUpdateUserLayoutPreferences(entityTableId, activeLayoutVariant);
  const { data, isInitialLoading: isLoadingPreferences } = useUserLayoutPreferences(
    entityTableId,
    activeLayoutVariant
  );
  const onExpandToggle = useCallback(
    (expanded) => updatePreferences({ customPreferences: { showMetrics: expanded } }),
    [updatePreferences]
  );
  return isLoadingPreferences ? /* @__PURE__ */ React.createElement(Spinner, null) : /* @__PURE__ */ React.createElement(EventsMetrics, { expanded: (_b = (_a = data.customPreferences) == null ? void 0 : _a.showMetrics) != null ? _b : true, onExpandToggle }, children);
};
export default EventsMetricsBarrier;
